module.exports = __webpack_public_path__ + "static/img/组 73(3).b1980a95.png";